import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'

export const machineServiceImageStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const machineServiceImageObject = z.object({
  id: z.string().uuid(),
  machineServiceId: z.string().uuid(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  description: z.string().nullish(),
  position: z.number(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  clientId: z.number().int().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: machineServiceImageStatus,
})

export const machineServiceImageCreateInputObject = z.object({
  id: z.string().uuid(),
  machineServiceId: z.string().uuid(),
  description: z.string().nullish(),
  position: z.number(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  format: enumerated({
    png: 'PNG',
    jpg: 'JPG',
    webp: 'WEBP',
  }),
})

export const machineServiceImageUpdateInputObject = z.object({
  id: z.string().uuid(),
  description: z.string().nullish(),
  position: z.number(),
  updatedAt: dateOrIsoString().nullish(),
})

export type MachineServiceImageType = z.infer<typeof machineServiceImageObject>
